// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"32af475aa796810fc2e5","454":"55f4e40d9011ea84ae60"}[chunkId] + ".js";
};